.tool-display {
  display: grid;
  grid-template:
    'icon label actions'
    '. description description'
    '. details details'
    'content content content' / auto 1fr auto;
  column-gap: var(--mantine-spacing-xs);
  /* &.sticky { */
  /*   position: sticky; */
  /*   top: var(--mantine-spacing-sm); */
  /*   &.is-stuck { */
  /*     z-index: 10; */
  /*   } */
  /* } */
}

.tool-content {
  position: relative;
  grid-area: content;
}

.status {
  display: grid;
  grid-area: 1 / 1 / -1 / -1;
  grid-template: subgrid / subgrid;
  anchor-name: --status;
  anchor-scope: all;
}

.icon {
  display: flex;
  grid-area: icon;
  place-content: center;
  align-items: center;
  width: 20px;
}

.label {
  display: flex;
  grid-area: label;
  column-gap: var(--mantine-spacing-xs);
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--mantine-font-size-xs);
  font-weight: calc(var(--mantine-heading-font-weight) * 0.714);
  color: color-mix(in oklab, var(--status-color, var(--mantine-color-dark-1)), var(--mantine-color-dark-0) 40%);
  white-space: nowrap;
  & > div {
    display: flex;
    column-gap: var(--mantine-spacing-xs);
    align-items: center;
  }
}

.actions {
  grid-area: actions;
  opacity: 0;
  transition: opacity 0.05s ease-out;
  position: fixed;
  position-anchor: --status;
  top: calc(anchor(top) - var(--mantine-spacing-xs) * 0.5);
  right: calc(anchor(right));
  display: flex;
  gap: var(--mantine-spacing-xs);
  z-index: 10;
  background: var(--mantine-color-dark-7);
  .tool-display:hover & {
    opacity: 1;
  }
}

.response-object {
  grid-area: details;
}

.response-table {
  max-height: 50cqh;
  padding-block: var(--mantine-spacing-xs);
  margin-block-start: var(--mantine-spacing-xs);
  overflow: auto;
  border-block: 1px solid var(--mantine-color-dark-4);
}

/* State-specific colors */
.complete .icon {
  color: var(--mantine-color-green-4);
}

.cancelled .icon {
  color: var(--mantine-color-red-4);
}

/* Content slot container */
.content-box {
  display: flex;
  & > * {
    min-width: 60cqw;
  }
  /* .is-stuck & > * { */
  /*   backdrop-filter: blur(4px); */
  /* } */
}

.content {
  position: relative;
  padding: var(--mantine-spacing-sm);
}

/* Awaiting input state */
.awaiting-input {
  padding: var(--mantine-spacing-sm);
}

/* ToolAside portal target — layout-neutral, children flow as siblings of the chrome */
.tool-aside {
  display: contents;
}
